import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

export const setSiteLayout = (data) => { cache = data; listeners.forEach((fn) => fn(data)); };

export function useSiteLayout() {
  const [layout, setLayout] = useState(cache);
  useEffect(() => {
    listeners.add(setLayout);
    if (!cache) api.get("/site-layout").then((r) => setSiteLayout(r.data)).catch(() => {});
    return () => listeners.delete(setLayout);
  }, []);
  return layout;
}

export const isExternal = (url = "") => /^(https?:|mailto:|tel:)/.test(url);
